import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useRef, useState } from 'react';
import './App.css';

import Nav from './Components/Nav/Nav'
import Footer from './Components/Footer/Footer'
import Message from './Components/Message/Message';

import Home from './Pages/Home/Home';
import Projects from './Pages/Projects/Projects';
import Research from './Pages/Research/Research';
import Certificates from './Pages/Certificates/Certificates';
import Events from './Pages/Events/Events';
import Blog from './Pages/Blog/Blog';
import About from './Pages/About/About';
import Contact from './Pages/Contact/Contact';
import PageNotFound from './Pages/404/404';

import ADAS from './Pages/Blog/Notes/ADAS/ADAS';
import DDPM from './Pages/Blog/Notes/DDPM/DDPM';

import RaspberryPi from './Pages/Blog/Guides/RaspberryPi/RaspberryPi';
import Arduino from './Pages/Blog/Guides/Arduino/Arduino';
import Git from './Pages/Blog/Guides/Git/Git';

function App() {
    const [messages, setMessages] = useState([]);   
    const timers = useRef(new Map());
    const message_life_span = 5;

    const ShowMessage = (text, state) => {
        const id = Date.now();
        setMessages(prev => [...prev, { id, message: text, state, visible: true }]);
        const timeout = setTimeout(() => RemoveMessage(id), message_life_span * 1000);
        timers.current.set(id, timeout);
    };

    const RemoveMessage = (id) => {
        setMessages(prev => prev.filter(msg => msg.id !== id));
        if (timers.current.has(id)) {
            clearTimeout(timers.current.get(id));
            timers.current.delete(id);
        }
    };
    const StopTimer = (id) => { if (timers.current.has(id)) clearTimeout(timers.current.get(id)); };
    const StartTimer = (id) => {
        if (timers.current.has(id)) clearTimeout(timers.current.get(id));
        const timeout = setTimeout(() => RemoveMessage(id), message_life_span * 1000);
        timers.current.set(id, timeout);
    };

    const Layout = ({ children }) => {
        const location = useLocation();
        const hideNavFooter = location.pathname === "/404";

        return (
            <>
                {!hideNavFooter && <Nav ShowMessage={ShowMessage}/>}
                <div className="message-stack">
                    {messages.map(msg => (
                        <Message
                            key={msg.id}
                            message={msg.message}
                            state={msg.state}
                            visible={msg.visible}
                            onClose={() => RemoveMessage(msg.id)}
                            onMouseEnter={() => StopTimer(msg.id)}
                            onMouseLeave={() => StartTimer(msg.id)}
                        />
                    ))}
                </div>
                {children}
                {!hideNavFooter && <Footer/>}
            </>
        );
    };

    return (
        <Router>
            <Layout>
                <Routes>
                    {/* Main Routes */}
                    <Route path="/" element={<Home/>}/>
                    <Route path="/Projects" element={<Projects ShowMessage={ShowMessage}/>}/>
                    <Route path="/Research" element={<Research/>}/>
                    <Route path="/Certificates" element={<Certificates/>}/>
                    <Route path="/Events" element={<Events/>}/>
                    <Route path="/Blog" element={<Blog ShowMessage={ShowMessage}/>}/>
                    <Route path="/About" element={<About ShowMessage={ShowMessage}/>}/>
                    <Route path="/Contact" element={<Contact ShowMessage={ShowMessage}/>}/>
                    <Route path="/404" element={<PageNotFound />} />
                    <Route path="*" element={<Navigate to="/404" replace />} />

                    {/* Nested Routes */}
                    <Route path="/DDPM" element={<DDPM/>}/>
                    <Route path="/ADAS" element={<ADAS/>}/>
                    <Route path="/RaspberryPi" element={<RaspberryPi/>}/>
                    <Route path="/Arduino" element={<Arduino/>}/>
                    <Route path="/Git" element={<Git/>}/>
                </Routes>
            </Layout>
        </Router>
    );
}

export default App;